/* eslint-disable no-nested-ternary */
import React, { PureComponent, useRef, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';
import { getTvArticle, getTvStruct, getTvStatic } from '../../../services/api';
import Footer from './components/footer';
import Header from './components/header';
import LeftNav from './components/leftNav';
import Article from './components/article';
import PersonList from './components/personList';
import ReactLoading from 'react-loading';
import Chip from 'Chip';
import ChipEdit from 'ChipEdit';
import transform from 'chipDataTransform';

// import Struct from './components/struct';
import styles from './index.css';

const ContactUs = errorBoundary(props => {
    return <div dangerouslySetInnerHTML={{ __html: props.content }} />;
});

class Layout extends PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };
    constructor(props) {
        super(props);

        this.state = {
            bodyContent: {},
            structData: {},
            pageInfo: this.props.content.leftNav[0],
            loading: true,
            staticData: '',
        };
    }
    async componentDidMount() {
        const { pageInfo } = this.state;

        this.getTvArticle(pageInfo.url);
    }

    getTvArticle = async id => {
        const data = await getTvArticle(id);

        this.setState({
            loading: false,
            bodyContent: data,
        });
    };
    getTvStruct = async id => {
        const data = await getTvStruct(id);

        this.setState({
            structData: data,
            loading: false,
        });
    };
    getTvStatic = async id => {
        const data = await getTvStatic(id);

        this.setState({
            staticData: data,
            loading: false,
        });
    };
    changePageInfo = async data => {
        const { pageInfo } = this.state;

        if (pageInfo.url !== data.url) {
            this.setState({
                loading: true,
                pageInfo: data,
            });
            if (data.type === 'article') {
                this.getTvArticle(data.url);
            }
            if (data.type === 'struct') {
                this.getTvStruct(data.url);
            }
            if (data.type === 'static') {
                this.getTvStatic(data.url);
            }
        }
    };
    renderContent = () => {
        const { pageInfo, bodyContent, structData, staticData } = this.state;

        if (pageInfo.type === 'article') {
            return (
                <div>
                    <div className={styles.phtv_title}>
                        <h2>{bodyContent.title}</h2>
                    </div>
                    <Article pageInfo={pageInfo} content={bodyContent} />
                </div>
            );
        } else if (pageInfo.type === 'static') {
            return (
                <div>
                    <div className={styles.phtv_title}>
                        <h2>Contact Us</h2>
                    </div>
                    <Chip
                        id={pageInfo.url}
                        type="static"
                        title="联系我们"
                        groupName="content"
                        content={staticData.content}>
                        <ContactUs />
                    </Chip>
                </div>
            );
        } else {
            return (
                <Chip id={pageInfo.url} type="struct" title="人物介绍" groupName="content" content={structData}>
                    <PersonList pageInfo={pageInfo} />
                </Chip>
            );
        }
    };
    render() {
        const {
            content: { footer, leftNav },
        } = this.props;
        const { loading } = this.state;

        return (
            <div className={styles.phtv_container}>
                <Header />
                <div className={styles.phtv_wrap}>
                    <Chip id="170121" type="struct" title="左侧导航" groupName="content" content={leftNav}>
                        <LeftNav changePageInfo={this.changePageInfo} />
                    </Chip>
                    <div className={styles.phtv_main}>
                        {loading ? (
                            <ReactLoading
                                type="spinningBubbles"
                                width={150}
                                height={150}
                                color="#f54343"
                                className={styles.spin}
                            />
                        ) : (
                            this.renderContent()
                        )}
                    </div>
                </div>
                <Footer content={footer} />
                <ChipEdit transform={transform} />
            </div>
        );
    }
}

export default errorBoundary(Layout);
